// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.viewer-backdrop {
  background-color: rgba(0, 0, 0, 0.9) !important;
}`, "",{"version":3,"sources":["webpack://./src/assets/style/v-viewer.css"],"names":[],"mappings":"AAAA;EACE,+CAA+C;AACjD","sourcesContent":[".viewer-backdrop {\n  background-color: rgba(0, 0, 0, 0.9) !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
